import classNames from "classnames";
import styles from "../ChatItem/ChatItem.module.scss";
import { Tooltip } from "components";
import { useSelector } from "redux/hooks";
import { IWorkspace } from "redux/actions";
import { useSidebar } from "hooks/services/ReSizeSidebar/ReSizeSidebar";
import {
  NewChatThreadWS,
  RemoveWSFiles,
  setEmptyThreadsHistory,
  setInProgressWS,
} from "redux/actions/workSpace";
import { RoutePaths } from "pages/routePaths";
import useRouter from "hooks/useRouter";

export const WorkspacesList = () => {
  const themeMode = useSelector((state) => state.authReducer.theme);
  const { workSpaces } = useSelector((state) => state.workSpaceReducer);
    const { sidebarWidth } = useSidebar();
 const { push, pathname } = useRouter();
// Extract current workspace ID from the URL path if available
 const pathWorkspaceId = pathname && pathname.includes(RoutePaths.WorkspaceHistory) 
 ? parseInt(pathname.split('/').pop() || '0', 10) 
 : null;
    const handleResetStates = () => {
        RemoveWSFiles();
        setInProgressWS("", "", "", "");
      };

   const handleConversation = (id: number) => {
      handleResetStates();
      setEmptyThreadsHistory();
      NewChatThreadWS(id);
      push(`/${RoutePaths.WorkspaceHistory}/${id}`);
    };

   // Sort workspaces by updated_at timestamp (most recent first)
   const sortedWorkspaces = workSpaces ? 
   [...workSpaces].sort((a, b) => {
     const dateA = new Date(a.updated_at).getTime();
     const dateB = new Date(b.updated_at).getTime();
     return dateB - dateA; // Descending order (newest first)
   }) : [];

 // Take only the top 5 most recently updated workspaces
 const recentWorkspaces = sortedWorkspaces.slice(0, 5);

  return (
    <div>
      {recentWorkspaces.map((space: IWorkspace) => {
        // Check if this workspace is active based on either activeWorkspaceId from Redux or URL path
        const isActive = space.id === pathWorkspaceId;
        return (
        <Tooltip
          key={space.id}
          control={
            <div className="px-[12px]">
            <div
              className={classNames("font-inter flex flex-col", styles.itemContainer, {
                [styles.itemContainerDark]: themeMode === "dark",
                [styles.itemContainerLight]: themeMode === "light",
                [styles.workSpace]: true,
               [styles.active]: isActive,
              })}
              onClick={() => handleConversation(space.id)}
              data-testid='select-chat'
            >
              <div className="flex-shrink-0 flex flex-row items-center justify-center">
                {space.emoji}
              </div>
              <div
                className={classNames(styles.itemMsgActionContainer, {
                  [styles.itemMsgActionContainerLight]: themeMode === "light",
                  [styles.itemMsgActionContainerDark]: themeMode === "dark",
                })}
              >
                <div className={classNames(styles.itemMessageContainer)}>
                  <div
                    className={classNames("fot-inter", styles.itemText, {
                            [styles.itemField]: sidebarWidth <= 325,
                                                [styles.itemFieldAdjust]: sidebarWidth <= 350 && sidebarWidth > 325,
                    })}
                  >
                    {space.name}
                  </div>
                </div>
              </div>
            </div>
            </div>
          }
          placement="right"
          theme={themeMode}
        >
          {space.name}
        </Tooltip>
     );
    })}
  </div>
);
}